// @ts-nocheck
import React, { useState } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import { toast } from 'react-toastify';
import SteamBulkRequest from './SteamBulkRequest';
import ReassignBulk from './ReassignBulk';
import ChangeStatusBulk from './ChangeStatusBulk';
import SlidingPane from 'react-sliding-pane';
import icons from '../../../constants/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export interface BulkActionsProps {
  done: () => void;
  cancel: () => void;
  items: unknown[];
}

function BulkActions({ done, cancel, items }: BulkActionsProps) {
  const { t } = useTranslation();
  const [bulkStatusChangeSlideoutOpen, setBulkStatusChangeSlideoutOpen] =
    useState(false);
  const [
    bulkStatusChangeSlideoutRequests,
    setBulkStatusChangeSlideoutRequests,
  ] = useState();

  const [bulkReassignSlideoutOpen, setBulkReassignSlideoutOpen] =
    useState(false);

  const [bulkReassignSlideoutRequests, setBulkReassignSlideoutRequests] =
    useState();

  const [bulkSteamRequestSlideoutOpen, setBulkSteamRequestSlideoutOpen] =
    useState(false);
  const [bulkSteamRequestSlideoutSKUs, setBulkSteamRequestSlideoutSKUs] =
    useState();

  const BulkActionItem = ({
    title,
    description,
    icon,
    iconClassname,
    onClick,
  }) => (
    <div
      className="col-sm-12 template p-0 bulk action-update"
      style={{ cursor: 'pointer' }}
      onClick={onClick}
    >
      <div className="template-detail p-4">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <div className="icon-wrapper">
        <FontAwesomeIcon icon={icon} className={iconClassname} />
      </div>
    </div>
  );

  const handleBulkStatusChange = () => {
    let requests = [];
    for (const i in items) {
      const row = items[i];
      if (row.games) {
        for (const j in row.games) {
          const requestRow = row.games[j];
          requests.push(requestRow.requestId);
        }
      } else {
        requests.push(row.id);
      }
    }
    setBulkStatusChangeSlideoutRequests(requests);
    setBulkStatusChangeSlideoutOpen(true);
  };

  const handleBulkReassign = () => {
    let requests = [];
    items.forEach((item) => {
      // if a group, it'll have games (requests) in it
      if (item.games) {
        item.games.forEach((requestRow) => {
          requests.push(requestRow.requestId);
        });
      } else {
        requests.push(item.id);
      }
    });
    setBulkReassignSlideoutRequests(requests);
    setBulkReassignSlideoutOpen(true);
  };
  const handleBulkSteamRequest = () => {
    let skus = [];
    for (const i in items) {
      const row = items[i];
      if (row.games) {
        for (const j in row.games) {
          const requestRow = row.games[j];
          if (requestRow.canOrderKeys) {
            skus = addSteamRequestItem(requestRow, requestRow.requestId, skus);
          }
        }
      } else if (row.canOrderKeys) {
        skus = addSteamRequestItem(row, row.id, skus);
      }
    }
    if (skus.length > 0) {
      setBulkSteamRequestSlideoutSKUs(skus);
      setBulkSteamRequestSlideoutOpen(true);
    } else {
      toast.error(
        t('None of the selected Key Requests are in the correct state')
      );
    }
  };

  const addSteamRequestItem = (row, keyRequestId, skus) => {
    const keyPoolRow = {
      keyWorkflowId: row.keyWorkflowId,
      keyWorkflowName: row.keyWorkflowName,
      keyProviderReference: row.keyProviderReference,
      requesterTag: row.requesterTag,
      numberOfKeys: row.numberOfKeys,
    };
    skus.push({
      skuId: row.skuId,
      gameName: row.gameTitle,
      skuName: row.skuName,
      keyRequestId: keyRequestId,
      packageTypeId: row.packageTypeId,
      keyPools: [keyPoolRow],
    });
    return skus;
  };

  return (
    <>
      <SlideoutLayout title={t('Bulk actions')} cancel={cancel}>
        <BulkActionItem
          title={t('Change status')}
          description={t(
            'Change the status of multiple requests with pending keys'
          )}
          icon={icons.CHANGE_STATUS}
          iconClassname="c-blue"
          onClick={handleBulkStatusChange}
        />
        <BulkActionItem
          title={t('Reassign')}
          description={t('Reassign the request to a user')}
          icon={icons.REASSIGN}
          iconClassname="c-red"
          onClick={handleBulkReassign}
        />
        <BulkActionItem
          title={t('Request on Steam')}
          description={t('Send an automated request to Steam')}
          icon={icons.REQUEST_ON_STEAM}
          onClick={handleBulkSteamRequest}
        />
      </SlideoutLayout>

      <SlidingPane
        isOpen={bulkStatusChangeSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setBulkStatusChangeSlideoutOpen(false)}
      >
        <ChangeStatusBulk
          done={() => {
            setBulkStatusChangeSlideoutOpen(false);
            done();
          }}
          cancel={() => setBulkStatusChangeSlideoutOpen(false)}
          requests={bulkStatusChangeSlideoutRequests}
        />
      </SlidingPane>

      <SlidingPane
        isOpen={bulkReassignSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setBulkReassignSlideoutOpen(false)}
      >
        <ReassignBulk
          done={() => {
            setBulkReassignSlideoutOpen(false);
            setBulkStatusChangeSlideoutRequests();
            done();
          }}
          cancel={() => setBulkReassignSlideoutOpen(false)}
          requests={bulkReassignSlideoutRequests}
        />
      </SlidingPane>

      <SlidingPane
        isOpen={bulkSteamRequestSlideoutOpen}
        hideHeader={true}
        from="right"
        className="large-side-panel"
        onRequestClose={() => setBulkSteamRequestSlideoutOpen(false)}
      >
        <SteamBulkRequest
          done={() => {
            setBulkSteamRequestSlideoutOpen(false);
            done();
          }}
          cancel={() => setBulkSteamRequestSlideoutOpen(false)}
          skus={bulkSteamRequestSlideoutSKUs}
        />
      </SlidingPane>
    </>
  );
}
export default BulkActions;
